__turbopack_context__.v({
  "ratingCount": "ProductBuySectionReviews-module-scss-module__wK9qWq__ratingCount",
  "reviewsButton": "ProductBuySectionReviews-module-scss-module__wK9qWq__reviewsButton",
  "writeReview": "ProductBuySectionReviews-module-scss-module__wK9qWq__writeReview",
});
